import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-mail-connector-error-dialog',
    templateUrl: './mail-connector-error-dialog.component.html',
    styleUrls: ['./mail-connector-error-dialog.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class MailConnectorErrorDialogComponent {
    public title = "Détail de l'erreur";

    constructor(
        public dialogRef: MatDialogRef<MailConnectorErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Ok'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
